import React from 'react'
import { CCard, CCardBody } from '@coreui/react-pro'
import { useNavigate } from 'react-router-dom'
import SETUP_PROGRESS_STEPS from './steps'

const StepperBar = ({ activeStepKey }) => {
  const navigate = useNavigate()

  return (
    <CCard className="mb-4">
      <CCardBody className="d-flex flex-wrap justify-content-between">
        {SETUP_PROGRESS_STEPS.map((step) => {
          const isActive = step.key === activeStepKey
          return (
            <div
              key={step.key}
              className="d-flex align-items-start"
              style={{ cursor: 'pointer', minWidth: 110 }}
              onClick={() => navigate(step.route)}
            >
              <div
                className={`d-flex align-items-center justify-content-center flex-shrink-0 me-2 ${
                  isActive ? 'bg-primary text-white' : 'bg-light text-medium-emphasis border'
                }`}
                style={{ width: 28, height: 28, borderRadius: '50%', fontWeight: 'bold' }}
              >
                {step.order}
              </div>
              <div>
                <div className={isActive ? 'fw-bold text-primary' : 'text-medium-emphasis'}>
                  {step.label}
                </div>
                <small className="text-medium-emphasis">{step.subLabel}</small>
              </div>
            </div>
          )
        })}
      </CCardBody>
    </CCard>
  )
}

export default StepperBar
